import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ADD_FRANCHISE_DEPOSITE } from "../../graphql/Mutation/Deposite.js";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useFileUpload } from "../../Common/PreSignUrl.jsx";
import SpinLoader from "../../components/SpinLoader.js";



const FranchiseDepositeAddModal = ({ onClose, selectedRow, setSelectedRow }) => {

    const [isLoading, setIsLoading] = useState(false);
    const { handleFileUpload } = useFileUpload();
    const [preview, setPreview] = useState(null);
    const [addDeposit, { loading }] = useMutation(ADD_FRANCHISE_DEPOSITE);
    const handleFileChange = (event, keyPrefix, folderName) => {
        if ((!event?.target?.files || !event?.currentTarget?.files) || event?.target?.files?.length === 0) {
            setIsLoading(false);
            // console.log("===");
        }
        handleFileUpload({
            event,
            keyPrefix,
            setStateCallback: (url) => {
                const newUrl = url.split('/').slice(-2).join('/');
                // console.log('✌️newUrl --->', newUrl);
                if (keyPrefix === "DepositSlip") {
                    formik.setFieldValue("photo", newUrl);
                }
                setIsLoading(false);
            },
            setIsLoading,
            folderName
        });
    }

    const formik = useFormik({
        initialValues: {
            amount: "",
            transactionId: "",
            photo: null,
        },
        validationSchema: Yup.object({
            amount: Yup.number()
                .required("Amount is required")
                .positive("Amount must be positive"),
            transactionId: Yup.string().required("Transaction ID is required"),
            photo: Yup.mixed().required("Photo is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                // 2️⃣ Call GraphQL API
                const { data } = await addDeposit({
                    variables: {
                        franchiseId: selectedRow,
                        amount: parseFloat(values?.amount),
                        transactionId: values?.transactionId,
                        photo: values?.photo,
                    },
                });
                if (data?.addFranchiseDeposit?.id) {
                    onClose();
                    resetForm();
                    setSelectedRow(null);
                    toast.success("Deposit Added Successfully!");
                }
            } catch (error) {
                toast.error(error?.message);
            }
        },
    });

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] px-4">

            {/* Modal Box */}
            <div className="bg-white w-full sm:w-[450px] p-6 rounded-lg shadow-lg relative animate-fadeIn">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-600 hover:text-black"
                >
                    <IoClose size={22} />
                </button>

                <div className="flex justify-center items-center py-12 bg-white px-1">
                    <div className="w-full max-w-md bg-white border border-black rounded-xl shadow-md p-6">
                        <h2 className="text-xl font-bold text-black mb-4">Franchise Deposite</h2>

                        <form onSubmit={formik.handleSubmit} className="space-y-4">

                            {/* Amount */}
                            <div>
                                <label className="block text-sm font-medium text-black mb-1">
                                    Amount <span className="text-red-600">*</span>
                                </label>

                                <input
                                    type="number"
                                    name="amount"
                                    {...formik.getFieldProps("amount")}
                                    className={`w-full border rounded p-2 focus:outline-none 
                                ${formik.touched.amount && formik.errors.amount
                                            ? "border-red-600"
                                            : "border-black"
                                        }`}
                                    onWheel={(e) => e.target.blur()} // stop mouse wheel
                                    onKeyDown={(e) => {
                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                            e.preventDefault(); // block arrows ↑ ↓
                                        }
                                    }}
                                />

                                {formik.touched.amount && formik.errors.amount && (
                                    <p className="text-red-600 text-sm">{formik.errors.amount}</p>
                                )}
                            </div>

                            {/* Transaction ID */}
                            <div>
                                <label className="block text-sm font-medium text-black mb-1">
                                    Transaction ID <span className="text-red-600">*</span>
                                </label>

                                <input
                                    type="text"
                                    name="transactionId"
                                    {...formik.getFieldProps("transactionId")}
                                    className={`w-full border rounded p-2 focus:outline-none 
                                ${formik.touched.transactionId && formik.errors.transactionId
                                            ? "border-red-600"
                                            : "border-black"
                                        }`}
                                />

                                {formik.touched.transactionId && formik.errors.transactionId && (
                                    <p className="text-red-600 text-sm">{formik.errors.transactionId}</p>
                                )}
                            </div>

                            {/* Photo Upload */}
                            <div>
                                <label className="block text-sm font-medium text-black mb-1">
                                    Screenshot / Photo <span className="text-red-600">*</span>
                                </label>

                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleFileChange(e, "DepositSlip", "DepositSlip")}
                                    className={`w-full border rounded p-2 
                                ${formik.touched.photo && formik.errors.photo
                                            ? "border-red-600"
                                            : "border-black"
                                        }`}
                                />

                                {formik.touched.photo && formik.errors.photo && (
                                    <p className="text-red-600 text-sm">{formik.errors.photo}</p>
                                )}
                            </div>

                            {/* Preview */}
                            {preview && (
                                <img
                                    src={preview}
                                    alt="preview"
                                    className="w-full h-40 object-cover border border-black rounded mt-2"
                                />
                            )}

                            {/* Submit Button */}
                            <button
                                type="submit"
                                disabled={!formik?.isValid}
                                className="w-full bg-black text-white py-2 rounded hover:bg-gray-900 
                        transition disabled:bg-gray-400"
                            >
                                Submit {loading && <SpinLoader />}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FranchiseDepositeAddModal;
